<template>
  <div class="confirm-box" @click="click">
    <div class="body">
      <slot class="header" name="header">
        <div class="header">{{title}}</div>
      </slot>
      <div class="content">
        <slot name="content">
          {{content}}
        </slot>
      </div>
      <slot>
      </slot>
      <div class="footer">
        <button @click.stop="cancel" class="cancel">{{cancelLabel}}</button>
        <button @click.stop="confirm" class="confirm">{{confirmLabel}}</button>
      </div>
    </div>
    <slot name="hidden"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    content: {
      type: String,
      default: '提示'
    },
    cancelLabel: {
      type: String,
      default: '取消'
    },
    confirmLabel: {
      type: String,
      default: '确认'
    }
  },
  methods: {
    click () {
      this.$emit('click')
    },
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.confirm-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  .body {
    width:321px;
    background:rgba(255,255,255,1);
    border-radius:16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 12px;
    .header {
      padding-top: 24px;
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(0,0,0,1);
      line-height:22px;
      text-align: center;
    }
    .content {
      margin-top: 12px;
      text-align: center;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
      line-height:20px;
      max-width: 238px;
    }
    .footer {
      width: 100%;
      display: flex;
      margin-top: 32px;
      border-top: 1px solid #E5E5E5;
      height: 51px;
      border-radius: 0 0 16px 16px;
      button {
        background: #fff;
        width: 50%;
        border: none;
        outline: none;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:24px;
      }
      .cancel {
        border-bottom-left-radius: 16px;
      }
      .confirm {
        color:rgba(24,204,159,1);
        border-left: 1px solid #E5E5E5;
        border-bottom-right-radius: 16px;
      }
    }
  }
  .phone-input {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height:50px;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 4px 0px rgba(0,0,0,0.04);
    box-sizing: border-box;
    padding: 16px 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    input {
      width: 275px;
      height: 36px;
      background:rgba(245,245,245,1);
      border-radius:18px;
      padding: 7px 17px;
      border: none;
      outline: none;
      box-sizing: border-box;
    }
    ::-webkit-input-placeholder {
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
    }
    button {
      display: inline-block;
      width:70px;
      height:36px;
      background:rgba(0,0,0,1);
      box-shadow:0px 2px 12px 0px rgba(0,0,0,0.28);
      border-radius:4px;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:20px;
      border: none;
      outline: none;
    }
  }
}
</style>
